import React, { useEffect, useState } from "react";
import "./coupon.scss";
import sidebarActivePage from "../../stores/sidebarActivePage";
import snackbarStore from "../../stores/snackbarStore";
import SnackbarAlert from "../../components/snackbarAlert/snackbarAlert";
import TwoBreadcrumb from "../../components/breadcrumbs/TwoBreadcrumb";
import {
  Button,
  CircularProgress,
  FormControl,
  Grid,
  Input,
  InputAdornment,
  InputLabel,
  Pagination,
  Paper,
} from "@mui/material";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";

// Icon
import { IoIosAdd } from "react-icons/io";
import CouponCard from "../../components/couponCard/CouponCard";
import couponStore from "../../stores/couponStore";

const Coupon = () => {
  const defaultStartSlice = 0;
  const defaultEndSlice = 12;
  const SnackbarStore = snackbarStore();
  const SidebarActivePage = sidebarActivePage();
  const CouponStore = couponStore();
  const [filterCoupon, setFilterCoupon] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [startSlice, setStartSlice] = useState(defaultStartSlice);
  const [endSlice, setEndSlice] = useState(defaultEndSlice);
  const [activePage, setActivePage] = useState(1);
  const [pageCount, setPageCount] = useState(1);

  useEffect(() => {
    init();
  }, []);

  const init = () => {
    SidebarActivePage.setIsActive({ setPage: "Coupon" });
    if (SnackbarStore.massage !== "") {
      SnackbarStore.setIsOpen({ value: true });
    }
    
    CouponStore.clearCouponForm();
  };

  useEffect(() => {
    if (CouponStore.coupon) {
      setFilterCoupon(CouponStore.coupon.slice(0).reverse());
      const count = CouponStore.coupon.length / defaultEndSlice;
      setPageCount(parseInt(Math.ceil(count)));
    }
  }, [CouponStore.coupon]);

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [activePage]);

  useEffect(() => {
    if (CouponStore.coupon) {
      if (searchValue !== "") {
        const data = CouponStore.coupon.filter((item) => {
          return item.couponName
            .toLowerCase()
            .includes(searchValue.toLowerCase());
        });
        setFilterCoupon(data.slice(0).reverse());
        const count = data.length / defaultEndSlice;
        setPageCount(parseInt(Math.ceil(count)));
      } else {
        setFilterCoupon(CouponStore.coupon.slice(0).reverse());
        const count = CouponStore.coupon.length / defaultEndSlice;
        setPageCount(parseInt(Math.ceil(count)));
      }
    }
  }, [searchValue]);

  return (
    <div className="coupon">
      <SnackbarAlert
        isOpen={SnackbarStore.isOpen}
        alertVariant="filled"
        onClose={() => {
          SnackbarStore.setIsOpen({ value: false });
          SnackbarStore.setMassage({ value: "" });
        }}
        massage={SnackbarStore.massage}
      />
      <div className="heading">Coupon</div>
      <TwoBreadcrumb mainName="Coupon" mainLink="coupon" activeName="List" />
      <div className="btn-right-side flex">
        <Link to="/coupon/new">
          <Button variant="contained" className="btn" startIcon={<IoIosAdd />}>
            <p>New Coupon</p>
          </Button>
        </Link>
      </div>
      <Grid container sx={{ mt: 1 }}>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <FormControl sx={{ width: "100%" }} variant="standard">
            <InputLabel htmlFor="standard-adornment-search">
              <p>Search coupon name</p>
            </InputLabel>
            <Input
              value={searchValue}
              onChange={({ target: { value } }) => setSearchValue(value)}
              endAdornment={
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              }
            />
          </FormControl>
        </Grid>
      </Grid>
      <div className="main">
        {CouponStore.isLoading ? (
          <div className="process">
            <CircularProgress className="cProgress" />
          </div>
        ) : (
          <Grid container spacing={2} className="transition">
            {filterCoupon.length !== 0 ? (
              filterCoupon.slice(startSlice, endSlice).map((item) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={4}
                  className="transition"
                  key={item._id}
                >
                  <Paper elevation={3} sx={{ borderRadius: "5px" }}>
                    <CouponCard item={item} />
                  </Paper>
                </Grid>
              ))
            ) : (
              <Grid item container>
                <Grid item xs={12}>
                  <div className="noData">No Data</div>
                </Grid>
              </Grid>
            )}
            {filterCoupon.length !== 0 && (
              <Grid container item xs={12} className="pagination">
                <Pagination
                  page={activePage}
                  count={pageCount}
                  shape="rounded"
                  onChange={(event, value) => {
                    setActivePage(value);
                    setStartSlice(
                      parseInt(value * defaultEndSlice - defaultEndSlice)
                    );
                    setEndSlice(value * defaultEndSlice);
                    // window.scrollTo({ top: 50 });
                  }}
                />
              </Grid>
            )}
          </Grid>
        )}
      </div>
    </div>
  );
};

export default Coupon;
